export default {"theme":{"light":true,"themes":{"light":{"primary":"#3f51b5","secondary":"#b0bec5","accent":"#8c9eff","error":"#b71c1c"}}}}
